import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, Pagination, Controller, Thumbs } from 'swiper'

SwiperCore.use([Navigation, Pagination]);

const slideOptions = {
  slidesPerView: 1,
  autoplay: {
    delay: 5000,
  },
  loop: true,
  rebuildOnUpdate: true,
}

const BackgroundCarousel = ({ slides, layout }) => (
  <Swiper { ...slideOptions } >
    {
      slides.map( ( slide, index ) => (
        <SwiperSlide key={ index }>
          <div style={ { backgroundImage: `url(${slide.url})` } }></div>
        </SwiperSlide>
      ))
    }
  </Swiper>
)


export default BackgroundCarousel
